module.exports = __webpack_public_path__ + "img/8_17.c15a00bf.png";